import { createSlice } from '@reduxjs/toolkit';
import utils from 'tools/utils';

function getInitToken() {
  // TODO: 暂时解决方法
  const queryToken = utils.getQueryString('token');
  const redux = JSON.parse(
    localStorage.getItem('persist:redux') || JSON.stringify('')
  );
  if (queryToken && redux?.user) {
    if (JSON.parse(redux.user)?.token !== queryToken) {
      localStorage.removeItem('persist:redux');
    }
  }
  return queryToken;
}
function getTenant() {
  const tenant = utils.getQueryString('tenant');
  if (!tenant || tenant === 'undefined' || tenant === 'null') {
    return utils.getTenantAccordingToUA();
  }
  return tenant;
}

const initialState = {
  token: getInitToken(),
  roleToken: utils.getQueryString('roleToken'),
  tenant: getTenant(),
  curAddress: null,
  editorAddress: null,
  selectedRewardId: '',
  userInfo: {
    vip: {},
    user: {}
  },
  isAnonyUser: true,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateToken: (state, action) => {
      state.token = action.payload;
    },
    updateAddress: (state, action) => {
      state.curAddress = action.payload;
    },
    updateEditorAddress: (
      state,
      action
    ) => {
      state.editorAddress = action.payload;
    },
    updateRewardId: (state, action) => {
      state.selectedRewardId = action.payload;
    },
    updateUser: (state, action) => {
      const { payload } = action
      state.userInfo = payload;
      state.isAnonyUser = payload.user.user_type === 2
    }
  }
});

export const {
  updateUser,
  updateToken,
  updateAddress,
  updateEditorAddress,
  updateRewardId
} = userSlice.actions;
export default userSlice.reducer;
